export const getContrastColor = (color: string) => {
  if (color.length !== 7 || typeof color !== "string") {
    return "#fff";
  }
  const rgb = [0, 0, 0].map((_, i) => parseInt(color.substring(i * 2 + 1, i * 2 + 3), 16));
  const luma = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
  return luma >= 165 ? "#000" : "#fff";
};
